import React, { useContext, useEffect, useState } from 'react';
import LogContext from '../../context/LogContext';
import profileLogo from '../../media/user.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { accountScroll } from '../../utils/accountScroll';
import formatDate from '../../utils/formatDate';
import convertToLocalTime from '../../utils/convertToLocalTime';
import OrderProductsGallary from '../ui/OrderProductsGallary';
import getTruncatedTitles from '../../utils/getTruncatedTitles';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL
export default function MyOrders() {
  const myContext = useContext(LogContext);
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState([])
  const handelLogout = async () => {
    const response = await axios.get(`${backendUrl}/logout`, {
      credentials: true // Include cookies in the request
    });
    navigate('/', { replace: true });
    setTimeout(() => {
      window.location.reload();
    }, 0);
    console.log("Logout successfully");
  }
  const handleScroll = () => {
    if (window.innerWidth <= 576) {
      accountScroll('account-scroll');
    }
  }

  const setOrderStatusColor = (status) => {
    if (status === 'Cancelled') return '#ff0000'
    else if (status === 'Delivered') return 'lightgreen'
    else if (status === 'Dispatched') return 'yellow'
    else if (status === "Out for Delivery") return 'orange'
    else if (status === "Placed") return 'green'
  }

  const handleSearch = async (e) => {
    // e.preventDefault();
    // if (e.target.value==="") return
    try {
      const response = await fetch(`${backendUrl}/getSearchedUserOrders`, {
        method: 'POST',
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ email: myContext.user.email, search: e.target.value })
      });
      if (response.ok) {
        const data = await response.json();
        setOrders([...data].reverse())
      }
    } catch (error) {
      console.log("Some error occured", error);
    }
  }
  const cancleOrder = async (orderID) => {
    try {
      const response = await fetch(`${backendUrl}/updateOrderStatus`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({ orderID, status: 'Cancelled', email: myContext.user.email }),
      credentials: "include"
    });
      if (response.ok) {
        alert('Order cancelled!');
        getOrders();
      }
    } catch (error) {
      console.log('Some error Occured', error)
    }
  }
  const getOrders = async () => {
    try {
      const response = await fetch(`${backendUrl}/getUserOrders`, {
        method: 'POST',
        headers: {
          "content-type": 'application/json'
        },
        body: JSON.stringify({ email: myContext.user.email })
      });
      if (response.ok) {
        const data = await response.json();
        setOrders([...data].reverse());
      }
    } catch (error) {
      console.log("Some error occured", error);
    }
  }
  useEffect(() => {
    getOrders();
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.innerWidth <= 576) {
        accountScroll('account-scroll');
      }
    }, 100); // You might increase this to 300ms if DOM isn't fully ready

    return () => clearTimeout(timer); // cleanup in case the component unmounts quickly
  }, []);

  return (
    <div className='profile' >
      <div className='row'>
        <div className='col-sm-4 col-xs-12'>
          <div style={{ display: 'flex' }} className='hello'>
            <img src={profileLogo} alt="" />
            {/* <p className='hello-text'>Hello!</p> */}
            <p className='name-text'>{myContext.user.firstName + " " + myContext.user.lastName}</p>
          </div>
          <div className='profile-list'>
            <p className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/orders'); handleScroll() }}><i className="fa-solid fa-bag-shopping"></i> <span className='head'>Orders</span> <hr /></p>
            <ul className='account-settings'>
              <li className='list-item'><i className="fa-solid fa-user"></i><span className='head'> Account Settings</span></li>
              <li className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/personal-info'); handleScroll() }}>Personal Information</li>
              <li className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/addresses'); handleScroll() }}>Manage Addresses</li>
              {/* <li className='list-item' style={{cursor:"pointer"}} onClick={()=>{setCurrentRoute('address')}}>PAN Card Information<hr /></li> */}

            </ul>
            <ul>
              <li className='list-item'><i className="fa-solid fa-briefcase"></i> <span className='head'>My Stuff</span></li>
              {/* <li className='list-item' style={{cursor:"pointer"}}>My Copouns</li> */}
              {/* <li className='list-item' style={{cursor:"pointer"}}>My Reviews & Ratings</li> */}
              {/* <li className='list-item' style={{cursor:"pointer"}} onClick={()=>{setCurrentRoute('address')}}>All Notifications</li> */}
              <li className='list-item' style={{ cursor: "pointer" }} onClick={() => { navigate('/account/wishlist'); handleScroll() }}>My Whitlist<hr /></li>

            </ul>
            <div id='account-scroll'>
              <p className='list-item' style={{ cursor: "pointer" }} onClick={handelLogout}><i className="fa-solid fa-right-from-bracket"></i> Logout</p>
            </div>
          </div>
        </div>
        <div className='col-sm-8 col-xs-12'>
          <div className='myOrders'>
            <div className='searchBar' style={{ display: "flex" }}>
              <input className='input' type="text" placeholder='Search order here ...' onChange={handleSearch} />
              <button className='btn-cart'><i className="fa-solid fa-magnifying-glass"></i> &nbsp;&nbsp;&nbsp;Search</button>
            </div>
            <div className='products'>
              {orders.map((order, index) => (
                <div className='order-card' key={index}>
                  {/* Order Header */}
                  <div className="order-header" style={{ margin: '5px 0px' }}>
                    <div className='timings row'>
                      <div className='col-xs-4'>
                        <span className=''>{formatDate(order.orderDate)}</span>
                      </div>
                      <div className='col-xs-4'>
                      </div>
                      <div className='col-xs-4' >
                        {/* <span className='pull-right'>{convertToLocalTime(order.orderDate)}</span> */}
                        {(order.orderStatus === "Processing" || order.orderStatus == "Placed") &&
                          <span
                            className='text-danger pull-right'
                            onClick={() => cancleOrder(order.orderID)}
                            style={{ cursor: 'pointer' }}
                          >
                            Cancle 
                          </span>}
                      </div>
                    </div>

                  </div>
                  <div className='row order-middle'>
                    <div className='col-md-3'>
                      <OrderProductsGallary products={order.products} />
                    </div>
                    <div className='col-md-6'>
                      <p style={{ marginTop: '2rem' }}>
                        <span className='titles'>{getTruncatedTitles(order.products)}</span>
                      </p>
                      <p style={{ fontSize: "1.25rem", fontWeight: '500', letterSpacing: ".5px" }}>
                        <i className="fa-solid fa-circle"
                          style={{
                            color: `${setOrderStatusColor(order.orderStatus)}`,
                            fontSize: '1rem',
                            marginRight: '5px',
                            position: 'relative',
                            top: '-2.5px'
                          }}>
                        </i> Order is {order.orderStatus}
                      </p>
                      <p style={{ color: '#44413e', fontWeight: 500, marginBottom: '1rem' }}>
                        {/* <span className='btn-coupon'>{order.coupon ? order.coupon.code : "-"}</span> */}
                        <span className=''>&#8377; {order.orderAmount}</span>
                      </p>
                    </div>
                    <div className='col-md-3'>


                    </div>
                  </div>
                  <div className="order-header" style={{ margin: '5px 5px' }}>
                    <div className='status' style={{}}>
                        
                      </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}
